import 'css-chunk:src/feature/gift-card/CheckPanelGiftCards.module.scss';export default {
  "root": "CheckPanelGiftCards_root",
  "item": "CheckPanelGiftCards_item",
  "icon": "CheckPanelGiftCards_icon",
  "grid": "CheckPanelGiftCards_grid"
};